import { Web3Address } from 'multirpc-sdk';
import { createSelector } from '@reduxjs/toolkit';

import { RootState } from 'store';
import { selectIsLoggedIn } from 'modules/auth/store/selectors';

import { MINIMAL_TOKENS_LIMIT } from '../const';
import {
  selectAllowedJWTsCount,
  selectAllowedJWTsCountState,
} from '../action/fetchAllowedJWTsCount';
import { selectJWTs } from '../action/fetchJWTs';

export const selectJwtTokenManager = (state: RootState) =>
  state.jwtTokenManager;

export const selectUserEndpointTokens = createSelector(selectJWTs, jwts =>
  jwts.map(jwt => jwt.userEndpointToken),
);

export const selectHasJwtManagerAccess = createSelector(
  selectAllowedJWTsCountState,
  selectAllowedJWTsCount,
  selectIsLoggedIn,
  ({ isLoading, isSuccess, isUninitialized }, allowedJwtsCount, isLoggedIn) =>
    isLoggedIn &&
    !isUninitialized &&
    !isLoading &&
    isSuccess &&
    allowedJwtsCount >= MINIMAL_TOKENS_LIMIT,
);

const defaultConfig = {};

export const selectTokenManagerConfig = createSelector(
  selectJwtTokenManager,
  (_state: RootState, currentAccount: Web3Address) => currentAccount,
  (manager, currentAccount) => manager[currentAccount] ?? defaultConfig,
);
